export default ({ authorizedGET }, endpoints) => {
  const list = async () => authorizedGET(endpoints.samples.list);

  return {
    list,
  };
};
